import { AccordionStyleConfigurations, GlobalThemeConfiguration } from '../config.type';
import { MappedStyles } from './global-themeing.utils';

const ACCORDION_SELECTOR = '#web-app .global-accordion';

// `headerCss` is authored as two fixed rules (`.collapsed{}` / `.expanded{}`); only their
// declaration bodies are kept, since the theme selectors are fixed by the runtime DOM.
const COLLAPSED_RULE = /\.collapsed\s*\{([^}]*)\}/;
const EXPANDED_RULE = /\.expanded\s*\{([^}]*)\}/;

function extractRuleBody(headerCss: string | undefined, rule: RegExp): string {
  return rule.exec(headerCss ?? '')?.[1]?.trim() ?? '';
}

export function mapAccordionStylesToCssString(theme: GlobalThemeConfiguration): MappedStyles {
  const result: MappedStyles = {};
  const config = theme?.accordionConfigurations;
  if (!config) return result;

  const collapsedCss = extractRuleBody(config.headerCss, COLLAPSED_RULE);
  if (collapsedCss) {
    result[`${ACCORDION_SELECTOR} .accordion-trigger[data-state='closed']`] = collapsedCss;
  }

  const expandedCss = extractRuleBody(config.headerCss, EXPANDED_RULE);
  if (expandedCss) {
    result[`${ACCORDION_SELECTOR} .accordion-trigger[data-state='open']`] = expandedCss;
  }

  if (config.contentCss?.trim()) {
    result[`${ACCORDION_SELECTOR} .accordion-content`] = config.contentCss;
  }

  // An svgIcon name is not something CSS can render, so the stylesheet is only a carrier: the
  // widget reads this custom property back at runtime to pick its icon.
  if (config.collapsedIcon?.trim()) {
    result[ACCORDION_SELECTOR] = `--accordionCollapsedIcon: ${config.collapsedIcon.trim()};`;
  }

  return result;
}

export function accordionStyleDefaults(): AccordionStyleConfigurations {
  return {
    headerCss: '.collapsed{}\n.expanded{}',
    contentCss: '',
    collapsedIcon: '',
  };
}
